import {Component, OnInit} from '@angular/core';
import {ApiService} from "../service/api.service";
import {routePath} from 'sdv-common';
import {reload} from '../shared/constants';
import {TokenService} from "../service/token.service";
import {NetworkService} from "../service/network.service";
import {ExchangeService} from "../service/exchange.service";

@Component({
  selector: 'app-tokens',
  templateUrl: './tokens.component.html',
  styleUrls: ['./tokens.component.scss']
})
export class TokensComponent implements OnInit {

  constructor(public apiService: ApiService,
              public networkService: NetworkService,
              public exchangeService: ExchangeService,
              public tokenService: TokenService) {
    if (!this.apiService.hasRole('admin')) {
      reload(routePath.accessDenied);
    }
  }

  ngOnInit() {
  }

  getInstance(id, arr) {
    if (id > 0) {
      return arr.find(n => n.id === id);
    }
    return {
      name: 'undefined'
    };
  }
}
